const logo = require('assets/images/logo.png');

export { logo };
